import axios from "axios"
import { APIS } from "../../../../../../../utils/api-factory"
import { MULTIPART_TENANT_POST_HEADER, TENANT_POST_HEADER } from "../../../../../../../utils/apiHeaders"

export const getAllCredTransactions = (
  
  callBack,
  onError
) => {
  fetch(APIS.CRED_TRANSACTIONS_ALL,{headers:TENANT_POST_HEADER})
    .then(res => res.json())
    .then(json => {
       
      callBack(json)
    })
    .catch((e) => {
      onError(e)
    })
}
export const getAllCredTransactionsByMonth = (
  month,
  callBack,
  onError
) => {
  fetch(APIS.CRED_TRANSACTIONS_ALL_MONTH + (month ?? ""),{headers:TENANT_POST_HEADER})
    .then(res => res.json())
    .then(json => {
       
      callBack(json)
    })
    .catch((e) => {
      onError(e)
    })
}
export const getAllCredTransactionsByFilter = (
  debitBool,
  callBack,
  onError
) => {
  fetch(APIS.CRED_TRANSACTION_FILTER + (debitBool ?? false),{headers:TENANT_POST_HEADER})
    .then(res => res.json())
    .then(json => {
       
      callBack(json)
    })
    .catch((e) => {
      onError(e)
    })
}
export const getAllCredTransactionsBySearch = (
  search,
  callBack,
  onError
) => {
  fetch(APIS.CRED_TRANSACTIONS_SEARCH_TEXT + `${search}`,{headers:TENANT_POST_HEADER})
    .then(res => res.json())
    .then(json => {
       
      callBack(json)
    })
    .catch((e) => {
      onError(e)
    })
}
export const getAllExpenses = (
  
  callBack,
  onError
) => {
  fetch(APIS.GET_ALL_EXPENSE_CATEGORY,{headers:TENANT_POST_HEADER})
    .then(res => res.json())
    .then(json => {
       
      callBack(json)
    })
    .catch((e) => {
      onError(e)
    })
}
export const getAllDescription = (
  
  callBack,
  onError
) => {
  fetch(APIS.GET_ALL_DESCRIPTION,{headers:TENANT_POST_HEADER})
    .then(res => res.json())
    .then(json => {
       
      callBack(json)
    })
    .catch((e) => {
      onError(e)
    })
}
export const getTransactionMapping = (
  tabValue,
  callBack,
  onError
) => {
  fetch(APIS.CRED_TRANSACTION_MAPPING + `${tabValue==="maped"?true:false}`,{headers:TENANT_POST_HEADER})
    .then(res => res.json())
    .then(json => {
       
      callBack(json)
    })
    .catch((e) => {
      onError(e)
    })
}
export const addTransactionCsvFile = (
  file,
  callBack,
  onError
) => {
   const formData = new FormData();
    formData.append('file', file);
    console.log(formData);
    axios.post(APIS.SAVE_TRANSACTION_BY_CSV, formData, {
      headers:MULTIPART_TENANT_POST_HEADER,
    }).then(json => {
      
      callBack(json.data)
    })
    .catch((e) => {
      console.log(e);
      onError("Try again")
      
    })
}
export const getAllSubCategory = (
  
  callBack,
  onError
) => {
  fetch(APIS.GET_ALL_EXPENSE_SUB_CATEGORY,{headers:TENANT_POST_HEADER})
    .then(res => res.json())
    .then(json => {
       
      callBack(json)
    })
    .catch((e) => {
      onError(e)
    })
}
export const getSortedCredTransactions = (
  sortBy,
  dataType,
  callBack,
  onError
) => {
  fetch(APIS.GET_SORT_CRED_TRANSACTION + `${sortBy}&order=${dataType}`,{headers:TENANT_POST_HEADER})
    .then(res => res.json())
    .then(json => {
       
      callBack(json)
    })
    .catch((e) => {
      onError(e)
    })
}
export const getBuisnessStatement = (
  callBack,
  onError
) => {
  fetch(APIS.GET_Business_Statement,{headers:TENANT_POST_HEADER})
    .then(res => res.json())
    .then(json => {
       
      callBack(json)
    })
    .catch((e) => {
      onError(e)
    })
}
export const getProduct = (
  callBack,
  onError
) => {
  fetch(APIS.SAVE_PRODUCT,{headers:TENANT_POST_HEADER})
    .then(res => res.json())
    .then(json => {
       
      callBack(json)
    })
    .catch((e) => {
      onError(e)
    })
}
export const saveProduct = (
  payload,
  callBack,
  onError
) => {
 axios.post(APIS.SAVE_PRODUCT, 
 payload,
  {
    headers: TENANT_POST_HEADER
  }
)
  .then(response => {
    callBack(response.data);
  })
  .catch(error => {
    onError(error);
  });
}
export const calculateProduct = (
  payload,
  callBack,
  onError
) => {
 axios.post(APIS.GET_MONTHLY_CASHFLOW, 
 payload,
  {
    headers: TENANT_POST_HEADER
  }
)
  .then(response => {
    callBack(response.data);
  })
  .catch(error => {
    onError(error);
  });
}
export const saveCategoryForTransaction = (
  payload,
  callBack,
  onError
) => {
 

axios.post(APIS.SAVE_TRANSACTION_CATEGORY,payload,{headers:TENANT_POST_HEADER}).then(response => {
    console.log('Response:', response.data);
    callBack(response.data)
  })
  .catch(error => {
    console.error('Error:', error);
    onError(error);
  });

}


export const getExpenseStatement = (
  callBack,
  onError
) => {
  fetch(APIS.EXPENSE_STATEMENT,{headers:TENANT_POST_HEADER})
    .then(res => res.json())
    .then(json => {
       
      callBack(json)
    })
    .catch((e) => {
      onError(e)
    })
}

export const getCombineStats = (
  callBack,
  onError
) => {
  fetch(APIS.GET_COMBINE_STATS,{method:"post",headers:TENANT_POST_HEADER})
    .then(res => res.json())
    .then(json => {
       
      callBack(json)
    })
    .catch((e) => {
      onError(e)
    })
}
export const getCashFlowStatement = (
  callBack,
  onError
) => {
  fetch(APIS.GET_CASHFLOW_STATEMENT,{headers:TENANT_POST_HEADER})
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      onError(e)
    })
}
export const getRemainingSummary = (
  callBack,
  onError
) => {
  fetch(APIS.GET_REMAINING_SUMMARY,{headers:TENANT_POST_HEADER})
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      onError(e)
    })
}
export const getAnnualTotalReport = (
  callBack,
  onError
) => {
  fetch(APIS.GET_REPORT,{headers:TENANT_POST_HEADER})
    .then(res => res.json())
    .then(json => {
      callBack(json)
    })
    .catch((e) => {
      onError(e)
    })
}
